import { assertSupabaseConfigured, supabase } from "../lib/supabase";
import type { DataHealthCheck } from "../types/admin";

export const dataHealthService = {
  async getChecks(): Promise<DataHealthCheck[]> {
    assertSupabaseConfigured();

    const { data, error } = await supabase.rpc("get_admin_data_health");

    if (error) {
      throw error;
    }

    return (data ?? []) as DataHealthCheck[];
  },
};
